import React from "react";
import { Navigate } from "react-router-dom";
import { DocsPage } from "./containers/api/DocsPage";
import { MainPage } from "./containers/cases/MainPage";
import { API_ROUTING, ROUTE_CONFIG } from "./AppRouting";

const routes: any = [
  {
    path: "/",
    element: <Navigate replace to="/docs/introduce" />,
  },
  {
    path: "/components",
    element: <MainPage />,
    children: [],
  },
  {
    path: "/docs",
    element: <DocsPage />,
    children: [],
  },
];

ROUTE_CONFIG.forEach((route) => {
  routes[1].children?.push({
    path: route.path,
    element: <route.component />,
  });
});

API_ROUTING.forEach((route) => {
  routes[2].children?.push({
    path: route.path,
    element: <route.component />,
  });
});

export default routes;
